import { useState } from "react";

export function useExportCsvWithObjParam<TRequest = Record<string, unknown>>() {
	const [isExporting, setIsExporting] = useState(false);

	const exportCsv = async (endpoint: string, request: TRequest): Promise<void> => {
		setIsExporting(true);
        console.log(request);
		try {
			const response: Response = await fetch(endpoint, {
				body: JSON.stringify(request),
				headers: {
					'Content-Type': 'application/json'
				},
				method: 'POST'
			});

			if (!response.ok) throw new Error('Failed to export file');

			const blob = await response.blob();

			let filename = 'export.csv';
			const disposition = response.headers.get('Content-Disposition');

			if (disposition?.includes('filename=')) {
				const match = disposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
				if (match && match[1]) {
					filename = match[1].replace(/['"]/g, '');
				}
			}

			const url = URL.createObjectURL(blob);
			const a = document.createElement('a');
			a.href = url;
			a.download = filename;
			document.body.appendChild(a);
			a.click();
			document.body.removeChild(a);
			URL.revokeObjectURL(url);
		} catch (error) {
			console.error('Export failed:', error);
		} finally {
			setIsExporting(false);
		}
	};

	return { exportCsv, isExporting };
}
